module.exports = __webpack_public_path__ + "media/tipping_game_start-14317bc856d1c6af33153921d44ab8c9.mp3";